import React, { Component } from "react";
// import {FormControl,Button,Row,Container,InputGroup} from "react-bootstrap";
import {Button,Box,HStack,Select} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBinoculars } from "@fortawesome/free-solid-svg-icons";

import ModalIdNameListDialog from "../../../components/Modals/ModalIdNameListDialog";

import LocalStorageService from "../../../services/LocalStorageService";
import LocalSuspendedDbService from "../../../services/LocalSuspendedDbService";

import { ObservationSessionMode } from "../../../models/ObservationSessionMode";
import RoleManager from "../../../models/RoleManager";
import { AppSecurityKey } from "../../../models/AppSecurityKey";

const createOption = (idName) => (
  { label: idName.name, value: idName.id }
);

export default class SchemaSelectorStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSuspendedTag: null,
      showSuspendedModal: false
    };

    this.localStorageService = new LocalStorageService();
    this.localSuspendedDbService = new LocalSuspendedDbService();

    this.onSchemaChange = this.onSchemaChange.bind(this);

    this.onResumeSuspendedObservation = this.onResumeSuspendedObservation.bind(this);

    this.onSuspendedModalOpenRequest = this.onSuspendedModalOpenRequest.bind(this);
    this.onSuspendedModalCloseRequest = this.onSuspendedModalCloseRequest.bind(this);
    this.onSuspendedModalOkRequest = this.onSuspendedModalOkRequest.bind(this);
  }


  async onSchemaChange(ev) {
    this.props.onCurrentSchemaIdUpdateRequest(ev.target.value);
  }


  async onResumeSuspendedObservation(suspendedTag)
  {
    this.props.onToastRequest("information", "resuming suspended observation on tag " + suspendedTag);
    var suspendedObservationResponse = await this.localSuspendedDbService.fetchObservation(this.props.userSession.gcid, suspendedTag);
    if (suspendedObservationResponse.hasError)
    {
      this.props.onToast("error", "There was a problem fetching the suspended observation.");
      return;
    }
    var suspendedObservation = suspendedObservationResponse.data;
    this.localSuspendedDbService.deleteObservation(suspendedTag);
    // tbd - refresh suspended tag list!
    var allTagsResponse = await this.localSuspendedDbService.fetchAllSuspendedTags();
    this.props.onSuspendedObservationChange(allTagsResponse.data);
    this.props.onObservationPageRequest(ObservationSessionMode.RESUME, suspendedObservation.suspendInfo.schemaId, suspendedObservation);

  }


  async onSuspendedModalOpenRequest(e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    if ((this.props.suspendedTags) && (this.props.suspendedTags.length < 1) )
    {
        this.props.onToastRequest("warning", "You have no observations currently in suspension.");
        return;
    }
    this.setState({ showSuspendedModal: true });
}

onSuspendedModalCloseRequest(e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    this.setState({ showSuspendedModal: false });
}

async onSuspendedModalOkRequest(existingValue, newValue) 
{
    this.onSuspendedModalCloseRequest();
    this.onResumeSuspendedObservation(newValue);
}




  render() {

    const schemaList = this.props.userSession.schemas ?? [];
    const currentSchemaId = this.props.currentSchemaId ?? "";
    const hasSuspendedTags = ((this.props.suspendedTags) && (this.props.suspendedTags.length > 0));
    const suspendedList = (this.props.suspendedTags) ? this.props.suspendedTags.map((s) => { return {"id": s, "name": s}}) : []; 
    const existingSuspendedValue = {id: "", name: ""}
    const canResume = RoleManager.hasRoleRights(AppSecurityKey.RESUME_OBSERVATION, this.props.userSession.token);

    return (
      <Box style={{  backgroundColor: "#0a597e", borderRadius: '5px', width: "100%", padding: "15px", minWidth: "400px" }}>

        <ModalIdNameListDialog
                    id="suspendeddialog"
                    show={this.state.showSuspendedModal}
                    title="Suspended Observation Tags"
                    placeholder="Suspended Tags"
                    onModalCloseRequest={this.onSuspendedModalCloseRequest}
                    onModalOkRequest={this.onSuspendedModalOkRequest}
                    existingValue={existingSuspendedValue}
                    dataList={suspendedList}
        />

        {/* <Text fontSize={{ base: '28px', md: '32px', lg: '36px' }} color='white'>QA Observations</Text> */}
        <HStack spacing={2}>
          
          <Select
            id="schemalookup"
            as="select"
            // placeholder="schema"
            type="dropdown"
            autoComplete="on"
            value={currentSchemaId}
            onChange={(ev) => this.onSchemaChange(ev)}
            name="schemaSelection"
            bg='white'
            
          >
            {schemaList.map((sch) => 
              {
                if (sch !== 'ALL') return <option key={sch}>{sch}</option>
              }
            )}
          </Select>

          <Button id="newInspectButton" 
          leftIcon={<FontAwesomeIcon icon={faBinoculars} color="white" />} 
          _disabled={(currentSchemaId)}
          onClick={(e) => this.props.onObservationPageRequest(ObservationSessionMode.ADD, currentSchemaId, e)}
          size='lg'
          bg='#0095c8'
          color='white'
          fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Add New
          </Button>

          {hasSuspendedTags && (canResume) && 
          <Button id="resumeButton" 
          leftIcon={<FontAwesomeIcon icon={faBinoculars} color="white" />} 
          onClick={(e) => this.onSuspendedModalOpenRequest()} //</HStack>this.props.onObservationPageRequest(ObservationSessionMode.ADD, "BLUEBERRY", e)}
          size='lg'
          bg='#0095c8'
          color='white'
          fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Resume
          </Button>
          }



        </HStack>
      </Box>

      


    );
  }
}
